// Location service for handling GPS location updates
class LocationService {
  constructor() {
    this.watcherId = null
    this.callbacks = []
    this.currentLocation = null
    this.isValidLocation = false
  }

  // Start watching location
  startWatching(callback) {
    if (typeof callback === 'function') {
      this.callbacks.push(callback)
    }

    // If already watching, don't start again
    if (this.watcherId) {
      return
    }

    // Check if geolocation is supported
    if (!navigator.geolocation) {
      console.warn('Geolocation is not supported by this browser')
      return
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 30000
    }

    this.watcherId = navigator.geolocation.watchPosition(
      (position) => {
        this.handleLocationUpdate(position)
      },
      (error) => {
        console.error('Error getting location:', error)
        this.handleLocationError(error)
      },
      options
    )

    console.log('Location watching started')
  }

  // Stop watching location
  stopWatching() {
    if (this.watcherId) {
      navigator.geolocation.clearWatch(this.watcherId)
      this.watcherId = null
      console.log('Location watching stopped')
    }
  }

  // Handle location update
  handleLocationUpdate(position) {
    const location = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      accuracy: position.coords.accuracy,
      heading: position.coords.heading,
      speed: position.coords.speed,
      timestamp: position.timestamp
    }

    this.currentLocation = location
    this.isValidLocation = true

    // Notify all callbacks
    this.callbacks.forEach(callback => {
      try {
        callback(location)
      } catch (error) {
        console.error('Error in location callback:', error)
      }
    })
  }

  // Handle location error
  handleLocationError(error) {
    console.error('Location error:', error)
    this.isValidLocation = false

    // Notify callbacks with null location
    this.callbacks.forEach(callback => {
      try {
        callback(null)
      } catch (error) {
        console.error('Error in location error callback:', error)
      }
    })
  }

  // Get current location
  getCurrentLocation() {
    return this.currentLocation
  }

  // Check if location is valid
  isValid() {
    return this.isValidLocation
  }

  // Remove callback
  removeCallback(callback) {
    const index = this.callbacks.indexOf(callback)
    if (index > -1) {
      this.callbacks.splice(index, 1)
    }
  }

  // Clear all callbacks
  clearCallbacks() {
    this.callbacks = []
  }
}

// Create singleton instance
const locationService = new LocationService()

export default locationService 